interface AccessDeniedViewProps {
  email: string | null;
}

export default function AccessDeniedView({ email }: AccessDeniedViewProps) {
  return (
    <div className="not-configured" data-testid="access-denied-view">
      <h2 style={{ marginTop: 0 }}>Access denied</h2>
      <p>
        {email ? (
          <>
            The account <strong>{email}</strong> isn&apos;t authorized for bevi-ailab.
          </>
        ) : (
          <>Your account isn&apos;t authorized for bevi-ailab.</>
        )}
      </p>
      <p className="muted">Ask an admin to grant you access and then refresh.</p>
    </div>
  );
}
